import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import ReportTableSampleDisplay from "../../flows/item/Shared/ReportTableSampleDisplay";
import MaterialModal from "../MaterialModal";
import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";

const tableFlowReportPreviewModalProps = {
    // Injected from Redux
    modalProps: PropTypes.shape({ tableKey: PropTypes.number }).isRequired,
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
};

type TableFlowReportPreviewModalProps = PropTypes.InferProps<typeof tableFlowReportPreviewModalProps>;

const TableFlowReportPreviewModal: React.FC<TableFlowReportPreviewModalProps> = ({
    modalProps = { tableKey: null },
    isOpen,
}: TableFlowReportPreviewModalProps) => {
    const dispatch = useDispatch();

    const { tableKey } = modalProps;

    const hide = () => dispatch(hideModal("PREVIEW_TABLE_RESULTS"));

    return (
        <MaterialModal
            id="table-flow-report-preview"
            title="Table Preview"
            showPrimaryButton={false}
            maxWidth="xl"
            fullWidth={true}
            isOpen={Boolean(isOpen)}
            onClose={hide}
            cancelButtonText="Close"
        >
            {isOpen ? <ReportTableSampleDisplay tableKey={tableKey} /> : null}
        </MaterialModal>
    );
};

export default withModal(TableFlowReportPreviewModal, "PREVIEW_TABLE_RESULTS");
